import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormTextareaField, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { TooltippedIcon } from '@mews-commander/ui';
import { ResourceCategory } from '@mews-commander/data-access';
import { getCurrentEnterpriseDefaultLanguageCode } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { LanguageLabel } from '@mews-commander/legacy-form';
import { FormFields, FormValues } from '../../../schema';

interface DescriptionProps {
    data?: ResourceCategory[];
}

export const DescriptionField: FC<DescriptionProps> = ({ data }) => {
    const defaultLanguageCode: string = useCommanderSelector(getCurrentEnterpriseDefaultLanguageCode);

    const { watch, setValue } = useFormContext<FormValues>();

    const selectedSpaceCategoryId = watch(FormFields.PromotedResourceCategoryId);

    useEffect(() => {
        const description = data?.find((item) => item.id === selectedSpaceCategoryId)?.description || '';
        setValue(FormFields.Description, description);
    }, [data, selectedSpaceCategoryId, setValue]);

    const label = (
        <Typography textStyle="bodyMediumStrong" as="div">
            {lt(TextKey.Description)}
            {UnicodeEntity.Space}
            {UnicodeEntity.Dash}
            {UnicodeEntity.Space}
            <LanguageLabel languageCode={defaultLanguageCode} />
        </Typography>
    );

    const icon = (
        <TooltippedIcon
            size="small"
            value={IconName.Info}
            tooltip={lt(TextKey.PromotedServiceAssignmentChangeDescriptionInfoMessage)}
        />
    );

    return <FormTextareaField captionIconWithTooltip={icon} name={FormFields.Description} label={label} readOnly />;
};
